import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { AiFillStar, AiOutlineStar } from 'react-icons/ai'

import { pick } from '@styled-system/props'

import { Text } from 'Components/UI'

import { Container, StarHolder, StarsHolder } from './styles'

const STARS = [1, 2, 3, 4, 5]
const keyName = 'startupcraft-ratings'

function Rating({ postId, ...rest }) {
  const [hoverStarsHolder, setHoverStarsHolder] = useState(false)
  const [hoverRating, setHoverRating] = useState(0)
  const [rating, setRating] = useState(0)

  const handleHolderMouseEnter = () => {
    if (!rating) {
      setHoverStarsHolder(true)
    }
  }

  const handleStarMouseEnter = value => {
    if (!rating) {
      setHoverRating(value)
    }
  }

  const handleClick = useCallback(
    value => {
      const ratings = JSON.parse(localStorage.getItem(keyName)) ?? {}
      ratings[postId] = value
      localStorage.setItem(keyName, JSON.stringify(ratings))
      setRating(value)
    },
    [postId],
  )

  useEffect(() => {
    const ratings = JSON.parse(localStorage.getItem(keyName)) || {}
    setRating(ratings[postId] || 0)
  }, [postId])

  return (
    <Container {...pick(rest)}>
      <StarsHolder
        canHover={!rating}
        mr={2}
        onMouseEnter={handleHolderMouseEnter}
        onMouseLeave={() => setHoverStarsHolder(false)}
      >
        {STARS.map(star => (
          <StarHolder
            canHover={!rating}
            filled={hoverRating >= star || rating >= star}
            key={`Rating key - ${star}`}
            onClick={() => handleClick(star)}
            onMouseEnter={() => handleStarMouseEnter(star)}
            onMouseLeave={() => setHoverRating(0)}
          >
            {hoverStarsHolder && hoverRating < star ? (
              <AiOutlineStar />
            ) : (
              <AiFillStar />
            )}
          </StarHolder>
        ))}
      </StarsHolder>

      <Text>{rating}/5</Text>
    </Container>
  )
}

Rating.defaultProps = {
  postId: null,
}

Rating.propTypes = {
  postId: PropTypes.string,
}

export default Rating
